import React from 'react';
import {Box, Flex, Center, Button, Image, Divider, Heading, useToast} from '@chakra-ui/react';
import GaiLogo from '../../images/logo_300x129_transparent.png';
import FlexCard from '../../components/General/FlexCard';
import {useForm} from 'react-hook-form';
import {CustomInput} from '../../components/General/FormInputs';
import {FaEnvelope} from 'react-icons/fa';
import {User} from '../../service/Urls';
import {postNoAuth} from '../../service/ApiService';
import {useNavigate} from 'react-router-dom';

const ForgotPassword = () => {
  const toast = useToast();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm();

  const onSubmit = async data => {
    // Api says no otherwise, for requests that require only a string
    const quoteWrappedUsername = '"' + data.username + '"';
    const userRequest = await postNoAuth(User.FORGOT_PWD, quoteWrappedUsername);

    if (userRequest?.error) {
      toast({
        title: 'Error',
        description: userRequest.error,
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
      return;
    } else {
      toast({
        title: 'Success',
        description: 'Check your email for a reset link',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
      setTimeout(() => {
        navigate('/login', {replace: true});
      }, 2000);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Center mt="12">
        <FlexCard>
          <Flex justifyContent={'center'} mx="12">
            <Box>
              <Image mx={'30'} my="3" src={GaiLogo} maxW={{base: 'md', md: 'sm'}} />
              <Flex justifyContent={'center'}>
                <Heading>Forgot Password?</Heading>
              </Flex>
              <Divider my="5" />
              <Box my="4">
                <CustomInput id="username" name="Email or Username" register={register} errors={errors} required></CustomInput>
              </Box>
              <Button type="submit" w="100%" colorScheme="teal" leftIcon={<FaEnvelope />} my="5">
                Send Email
              </Button>
            </Box>
          </Flex>
        </FlexCard>
      </Center>
    </form>
  );
};
export default ForgotPassword;
// @param {id, name, register, errors, required=false}
